/**
 * created by lei lei
 *微博私信
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, Card, Icon, Avatar, List, Spin, Input, message} from 'antd';
import * as actions from "../../actions/weiBo";
import InfiniteScroll from 'react-infinite-scroller';
import * as utils from "../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import {getAllEmotionsList} from "../../actions/weiboEmotionsList";

const {TextArea} = Input;
const {Meta} = Card;
let background = '#ffffff';//'#0050B3'
let fontColor = 'black';//'#ffffff'
export default class PrivateLetter extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            userList: [],
            loading: false,
            hasMore: true,
            start: 1,
            size: 10,
            hasClick: false,
            clickCurrent: {},
            inputValue: '',
            userInfo: {},
            detailList: [],
            detailOriginalList: [],
            isLast: false,
            refreshFlag: false,
            emotionsDataSource:[],//表情包数据
            emotionsDataMap:{},//表情包数据对应的图片链接
        }
    }

    componentDidMount() {
        // this.getUserList();
        //  this.getUserInfor();
        /*setTimeout(() => {
            console.log(this.scrollRef)
        this.scrollRef&&this.scrollRef.current.scrollToBottom();
        });*/


    }

    // 组件清除时清除定时器
    componentWillUnmount(){
        clearInterval(this.Timer);
    }
    getUserInfor() {
        actions.getUserInfo(this.props.mediaCode, (data) => {
            this.state.userInfo = data;
            this.setState({})
        })
    }

    initEmotionsDataSource() {
        getAllEmotionsList(this.props.mediaCode, this.state.type, (data) => {
            if (data && data.length && data.length > 0) {

                let map ={}

                data.map(d=>{d.emotion.map(item=>{map[item.value] = item.icon})});

                this.setState({
                    emotionsDataSource: data,
                    emotionsDataMap: map
                });
            }
        });
    }

    //获取用户列表
    getUserList() {
        this.setState({
            loading: true,
        });
        let body = {
            start: this.state.start,
            size: this.state.size,
            mediaCode: this.props.mediaCode
        };
        actions.getWeiboMessageList(body, (data) => {
            if (data.length < this.state.size) {
                this.state.hasMore = false
            }
            data.forEach(item => {
                item.checked = false;
            });
            this.setState({
                userList: this.state.userList.concat(data),
                loading: false,
            });
        })
    }

    //开启私信
    showModal = () => {
        this.state.visible = true;
        this.state.userList = [];
        this.state.loading = false;
        this.state.hasMore = true;
        this.state.start = 1;
        this.state.hasClick = false;
        this.getUserList();
        this.getUserInfor();
        this.initEmotionsDataSource();
    };

    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        clearInterval(this.timer);
        this.setState({
            visible: false,
        });
    };

    render() {
        let height = "calc(60vh - "  +"70px)";
        return (
            <div>
                <Modal
                    title="私信"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width={900}
                    bodyStyle={{ padding: 20}}
                    footer={null}
                >
                    <div style={{display: 'flex',height:'60vh'}}>
                        <div style={{width: 322}}>
                            <div style={{height: 70, display: 'flex', lineHeight: '70px', background: background}}>
                                <div style={{margin: '0 15px 0 18px'}}><img
                                    style={{width: 50, height: 50, objectFit: 'cover', borderRadius: '50%'}}
                                    src={this.state.userInfo.profile_image_url}
                                    alt=""/></div>
                                <div style={{color: fontColor, fontSize: 16}}>{this.state.userInfo.screen_name}</div>
                            </div>
                            <div style={{background: '#f2f2f2', height: 1}}/>
                            <div style={{height: height, overflow: "auto", width: 322,border:'1px solid #f2f2f2'}}>
                                {this.renderUsrList()}
                            </div>
                            {/*<div style={{background: '#f2f2f2', height: 1}}/>*/}
                        </div>
                        <div style={{width: 538}}>
                            {this.state.hasClick ?
                                this.renderReplay()
                                :
                                this.renderNoClick()
                            }
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    //渲染无数据没点击的时候
    renderNoClick() {
        return (
            <div style={{
                textAlign: 'center',
                height: '60vh',
                lineHeight: '60vh',
                fontSize: 16,
                color: 'a3a7ae'
            }}>
                您还未选中或发起聊天，快去跟好友聊一聊吧
            </div>
        )
    }

    //渲染回复消息列表
    renderReplay() {
        let height = "calc(60vh - "  +"205px)";
        return (
            <div style={{height:"60vh"}}>
                <div style={{
                    fontSize: 16,
                    color: '#808080',
                    height: 70,
                    lineHeight: '70px',
                    paddingLeft: 20,
                }}>{this.state.clickCurrent.userName}</div>
                <div style={{background: '#f2f2f2', height: 1}}/>
                <div style={{height: height, background: '#eeeeee',}}>
                    <Scrollbars onScroll={this.onScroll} ref={(scrollRef) => {
                        this.scrollRef = scrollRef
                    }}>
                        {this.state.detailList.map((item, i) => {
                            if (item.type === 1) {
                                return (
                                    <div key={i}>
                                        <div style={{
                                            textAlign: 'center',
                                            fontSize: 12,
                                            color: '#a3a7ae'
                                        }}>{utils.formatDate(item.createTime.time)}</div>
                                        <div style={{display: 'flex', padding: 20}}>
                                            <div><img style={{width: 30, height: 30, borderRadius: '50%'}}
                                                      src={this.state.clickCurrent.imageUrl} alt=""/></div>
                                            <div style={{display: 'flex'}}>
                                                <div style={{
                                                    width: 0,
                                                    height: 0,
                                                    border: '5px solid white',
                                                    borderBottomColor: 'transparent',
                                                    borderLeftColor: 'transparent',
                                                    marginTop: 15,
                                                    marginLeft: 3
                                                }}></div>
                                                <div style={{
                                                    maxWidth: 358,
                                                    background: 'white',
                                                    lineHeight: '20px',
                                                    padding: '11px 16px',
                                                    borderRadius: '4px'
                                                }}>
                                                    {utils.showCommentEmotions(item.message,this.state.emotionsDataMap)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                )
                            } else {
                                return (
                                    <div style={{padding: 20}} key={i}>
                                        <div
                                            style={{textAlign: 'center',
                                                fontSize: 12,color: '#a3a7ae'}}>{utils.formatDate(item.createTime.time)}</div>
                                        <div style={{width: '358px', height: 1}}/>
                                        <div style={{float: 'right'}}>
                                            <div style={{float: 'right'}}><img
                                                style={{width: 30, height: 30, borderRadius: '50%',}}
                                                src={this.state.userInfo.profile_image_url} alt=""/></div>
                                            <div style={{
                                                width: 0,
                                                height: 0,
                                                border: '5px solid white',
                                                borderBottomColor: 'transparent',
                                                borderRightColor: 'transparent',
                                                marginTop: 15,
                                                marginLeft: 0,
                                                float: 'right'
                                            }}></div>
                                            <div style={{
                                                maxWidth: 358,
                                                background: 'white',
                                                lineHeight: '20px',
                                                padding: '11px 16px',
                                                borderRadius: '4px',
                                                float: 'right'
                                            }}>
                                                {utils.showCommentEmotions(item.message,this.state.emotionsDataMap)}
                                            </div>
                                        </div>
                                        <div style={{clear: 'both'}}/>
                                    </div>
                                )
                            }
                        })}

                    </Scrollbars>


                </div>
                <div style={{height: 135,}}>
                    <TextArea value={this.state.inputValue} onKeyDown={(e) => {
                        this.clickEnter(e);
                    }} onChange={(e) => {
                        this.setState({inputValue: e.target.value})
                    }} rows={4} style={{resize: 'none'}}/>
                    <div style={{position: 'relative',}}>
                        <div style={{
                            fontSize: 12,
                            color: '#a3aea7',
                            height: 36,
                            lineHeight: '36px',
                            position: 'absolute',
                            right: 20
                        }}>
                            按下Enter发送内容/ Ctrl+Enter换行
                        </div>
                    </div>
                </div>
                <div style={{background: '#f2f2f2', height: 1}}/>
            </div>
        )
    }

    //渲染用户列表
    renderUsrList() {
        return (
            <Scrollbars onScroll={this.onScrollUser} ref={(onScrollUserRef) => {
                this.onScrollUserRef = onScrollUserRef
            }}>{
                this.state.userList.map((item, i) => {
                    return (
                        <Card key={i}
                              style={{width: 320, height: 81, background: item.checked ? '#0050B3' : background}}
                              hoverable={true}
                              bordered={true}
                              onClick={() => {
                                  this.userListClick(item)
                              }}
                        >
                            <Meta
                                avatar={<img
                                    style={{width: 50, height: 50, objectFit: 'cover', borderRadius: '50%'}}
                                    src={item.imageUrl}/>}
                                title={<div style={{display: 'flex', position: 'relative'}}>
                                    <div style={{
                                        fontSize: 14,
                                        color: item.checked ? '#ffffff' : fontColor,
                                    }}>{item.userName}</div>
                                    <div style={{
                                        fontSize: 12, color: '#999999', position: 'absolute',
                                        right: 0
                                    }}>{utils.timeago(item.updateTime.time)}
                                    </div>
                                </div>}
                                description={<div style={{
                                    width: 203, overflow: 'hidden',
                                    textOverflow: 'ellipsis', fontSize: 14, color: '#999999',
                                    whiteSpace: 'nowrap'
                                }}>{utils.showCommentEmotions(item.messageList[0].message,this.state.emotionsDataMap)}   </div>}
                            />
                        </Card>

                    )
                })
            }
            </Scrollbars>
        )
    }

    //点击用户
    userListClick(item) {
        this.state.userList.forEach(item => {
            item.checked = false;
        });
        this.state.hasClick = true;
        item.checked = true;
        this.state.clickCurrent = item;
        this.state.isFirst = true;
        this.state.isLast = false;
        this.state.start = 1;
        if(!this.timer){
            this.Timer();
        }
        this.getWeiboMessageDetail();

    }

    //获取用户消息详情
    getWeiboMessageDetail() {
        let body = {
            mediaCode: this.props.mediaCode,
            uid: this.state.clickCurrent.uid,
            start: this.state.start,
            size: this.state.size,
        };
        if (this.state.start === 1) {
            this.state.detailOriginalList = [];
            this.state.detailList = [];
        }
        actions.getWeiboMessageDetail(body, (date) => {
            this.state.detailOriginalList = this.state.detailOriginalList.concat(date.messageList);
            if (date.messageList.length > 0) {
                this.state.detailList = this.state.detailOriginalList.reverse();
            }
            if (date.messageList.length < this.state.size) {
                this.state.isLast = true;
            } else {
                this.state.isLast = false;
            }
            if (this.state.start === 1) {
                setTimeout(() => {
                    this.state.isLast = false;
                    //设置数据滚动条在最底部
                    this.scrollRef && this.scrollRef.scrollToBottom();
                    this.state.refreshFlag = false;
                    console.log('一直刷新了')
                    //每隔15秒，获取用户消息详情。
                    // this.getWeiboMessageDetail();
                });
            }
            this.setState({});
        });
    }

    Timer = () => {
        this.timer = setInterval(() => {
            this.getWeiboMessageDetail();
        }, 1500);
    }

    //获取用户的列表加载更多
    onScrollUser = e => {

        if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            //console.log('到底了');
            //获取最新
            if (this.state.hasMore) {
                this.state.start++;
                this.getUserList();
            }

        }
    };

    //用户消息回复
    onScroll = e => {
        let currentPosition = this.scrollRef.getScrollTop();
        if(currentPosition<e.target.scrollHeight){
            clearInterval(this.timer);
            this.timer=null;
        }
        if (currentPosition === 0) {
            // console.log('上拉加载更多数据哦')
            if (!this.state.isLast) {
                this.state.start++;
                this.getWeiboMessageDetail()
            } else {
                if (this.state.start > 1) {
                    message.info('没有更多了！')
                }
            }

        }
        if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
            //console.log('到底了');
            //获取最新
            this.state.start = 1;
            //this.getWeiboMessageDetail();
            if(!this.timer){
                this.Timer();
            }
        }
    };

//enter 发送保存消息
    clickEnter(event) {
        if (event.ctrlKey && event.keyCode === 13) {
            this.setState({inputValue: this.state.inputValue + '\n'});
            return
        } else {
            if (event.keyCode === 13) {
                let body = {
                    mediaCode: this.props.mediaCode,
                    msg: this.state.inputValue,
                    receiverId: this.state.clickCurrent.uid
                };
                event.cancelBubble = true;

                event.preventDefault();

                event.stopPropagation();
                if (this.state.inputValue) {
                    if (!this.state.inputValue.trim().length > 0) {
                        message.warn('请输入回复内容');
                        return;
                    }

                } else {
                    message.warn('请输入回复内容');
                    return;
                }
                actions.replyMsg(body, (date) => {
                    this.state.inputValue='';
                    this.state.start=1;
                    this.setState({});
                    if(!this.timer){
                        this.Timer();
                    }
                   /* this.getWeiboMessageDetail();
                    this.setState({inputValue: ''})*/
                });
            }
        }

    }


}